var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "generate-vehicle-trip-print"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getVehicleTripBagDetails()
      }
    }
  }, [_c('legend', [_vm._v("Generate Vehicle Trip Print")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vendor Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('vendorName')
    },
    attrs: {
      "options": _vm.VendorNameData,
      "selected-option": _vm.vendorNameObjData,
      "name": "vendorName",
      "placeholder": "Select Vendor Name"
    },
    on: {
      "select": _vm.selectedVendor
    },
    model: {
      value: (_vm.vendorName),
      callback: function($$v) {
        _vm.vendorName = $$v
      },
      expression: "vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('vendorName')),
      expression: "errors.has('vendorName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('vendorName')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.vendorLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('FromDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "FromDate"
    },
    on: {
      "change": _vm.checkToDate
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FromDate')),
      expression: "errors.has('FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FromDate')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('ToDate')
    },
    attrs: {
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "ToDate"
    },
    on: {
      "change": _vm.checkToDate
    },
    model: {
      value: (_vm.ToDate),
      callback: function($$v) {
        _vm.ToDate = $$v
      },
      expression: "ToDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ToDate')),
      expression: "errors.has('ToDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ToDate')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])])], 1)]), _vm._v(" "), (_vm.showTable == true) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Vehicle Trip Details")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "200px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No. of Bags")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Print Bag List")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Send Mail")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.VehicleTripBagDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.tripid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vendorname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehiclename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicleno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagcount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-print",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.printeVehicleTripBagDetails(data)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-envelope",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.sendMail(data)
        }
      }
    })])])
  }), 0)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.showModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Xpressbees Vehicle Trip Sheet"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Xpressbees Vehicle Trip Sheet")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm",
    attrs: {
      "id": "PrintSheet"
    }
  }, [(_vm.ResponseData.length <= 0) ? _c('div', [_c('h6', {
    staticStyle: {
      "margin-left": "308px"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.ResponseData.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "left"
    }
  }, [_c('span', [_c('b', [_vm._v("Print Date : ")]), _vm._v(_vm._s(_vm._f("moment")(_vm.PrintDate)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', [_c('b', [_vm._v("Print By : ")]), _vm._v(_vm._s(_vm.PrintBy))])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('b', [_vm._v("Xpressbees Vehicle Trip Sheet")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Date : " + _vm._s(_vm._f("moment")(_vm.tripSheetData.InvoiceDate)))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("Source Hub : " + _vm._s(_vm.tripSheetData.OriginHubName))])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Vehicle No. : " + _vm._s(_vm.tripSheetData.VehicleName) + " - " + _vm._s(_vm.tripSheetData.VehicleNo))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Vendor :")])])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Coloader Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No of Shipmnents")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vol. Wt.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Phy. Wt.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.ResponseData), function(data, index) {
    return (_vm.ResponseData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("--")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingbagcnt))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("--")])]) : _vm._e()
  }), _vm._v(" "), (_vm.ResponseData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Total Bags : ")])]), _vm._v(" "), _c('td', {
    staticClass: "text-left",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.ResponseData.length))]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b', [_vm._v("Total :")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm._f("TotalShipment")(_vm.ResponseData))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm._f("TotalVolWt")(_vm.ResponseData))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("TotalPhyWt")(_vm.ResponseData)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("--")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Open KM : ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }), _vm._v(" "), _c('td', [_c('b', [_vm._v("Close KM :")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "5"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_c('br'), _c('br'), _vm._v("Supervisor Name & Sign")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_c('br'), _c('br'), _vm._v("Driver Name &b Sign")])]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_c('br'), _c('br'), _vm._v("Receiver Name & Sign")]), _c('br')])])], 2), _vm._v(" "), _c('tbody')])]) : _vm._e()]), _vm._v(" "), (_vm.ResponseData.length > 0) ? _c('div', {
    staticClass: "float-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": _vm.printSheet
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.showemailpage == true) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Send Mail"
    },
    model: {
      value: (_vm.showemailpage),
      callback: function($$v) {
        _vm.showemailpage = $$v
      },
      expression: "showemailpage"
    }
  }, [_c('fieldset', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Send Mail")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeSendMailPage
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mail ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-envelope'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailId),
      expression: "mailId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('mailId')
    },
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "name": "mailId",
      "id": "mailId",
      "placeholder": "Enter MailId, Use Comma For Multiple MailId's"
    },
    domProps: {
      "value": (_vm.mailId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailId = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.emailIdErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdErrorMSG))]) : _vm._e(), _vm._v(" "), (_vm.emailIdValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.emailIdValidationMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.SendMailFunction
    }
  }, [_vm._v("Send Mail")]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormForMail
    }
  }, [_vm._v("Reset Mail")]), _vm._v(" \n\n                  ")])])])])])])]) : _vm._e()], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e52b157c","hasScoped":true}!./src/views/components/GenerateVehicleTripPrint/GenerateVehicleTripPrint.html
// module id = 932
// module chunks = 2